import React from "react";
import {Button, Modal} from "react-bootstrap";
import Translate from "../../../../components/Translate";
import {Form, Formik} from "formik";
import NsFormikScrollToError from "../../../../components/NsFormikScrollToError";
import NsField from "../../../../components/fields/NsField";
import {
    TIPO_ELEMENTO_FORMULA,
    TIPO_ELEMENTO_LABEL,
    TIPO_ELEMENTO_LISTA, TIPO_ELEMENTO_SOTTOLIVELLO,
    TIPO_ELEMENTO_VALORE
} from "../../../../utility/common";

export default function ModalUpdElementoKpiView({
                                                    elemento,
                                                    show,
                                                    handleClose,
                                                    translate,
                                                    initialValuesTemplate,
                                                    formikRefTemplate,
                                                    SignupSchemaTemplate,
                                                    onSubmitFormTemplate,
                                                    salvaElemento,
                                                    tipiElemento,
                                                    aggiungiRiga,
                                                }) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            size={"lg"}
            keyboard={false}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{translate('Modifica elemento')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Formik
                    initialValues={initialValuesTemplate}
                    innerRef={formikRefTemplate}
                    validationSchema={SignupSchemaTemplate}
                    onSubmit={onSubmitFormTemplate}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"tipo"}
                                    label={"Tipo*:"}
                                    as={"select"}
                                    isInModal={true}
                                    options={tipiElemento}
                                    formikRef={formikRefTemplate}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            {
                                (values['tipo'] == TIPO_ELEMENTO_LABEL || values['tipo'] == TIPO_ELEMENTO_SOTTOLIVELLO) &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"label"}
                                        label={"Label*:"}
                                        formikRef={formikRefTemplate}
                                        as={"textarea"}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            {
                                (values['tipo'] == TIPO_ELEMENTO_LABEL || values['tipo'] == TIPO_ELEMENTO_SOTTOLIVELLO) &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"titolo_dettaglio"}
                                        label={"Titolo dettaglio informativo:"}
                                        formikRef={formikRefTemplate}
                                        as={"textarea"}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            {
                                (values['tipo'] == TIPO_ELEMENTO_LABEL || values['tipo'] == TIPO_ELEMENTO_SOTTOLIVELLO) &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"testo_dettaglio"}
                                        label={"Testo dettaglio informativo:"}
                                        formikRef={formikRefTemplate}
                                        as={"textarea"}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            {
                                values['tipo'] == TIPO_ELEMENTO_VALORE &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"placeholder"}
                                        label={"Placeholder:"}
                                        formikRef={formikRefTemplate}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            {
                                values['tipo'] == TIPO_ELEMENTO_FORMULA &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"formula"}
                                        label={"Formula:"}
                                        formikRef={formikRefTemplate}
                                        as={"textarea"}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            {
                                values['tipo'] == TIPO_ELEMENTO_LISTA &&
                                <div className="col-md-6">
                                    <NsField
                                        name={"valori_lista"}
                                        label={"Valori previsti:"}
                                        formikRef={formikRefTemplate}
                                        as={"textarea"}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                            }
                            <div className="col-md-6">
                                <NsField
                                    name={"colspan"}
                                    label={"Colspan*:"}
                                    as={"number"}
                                    formikRef={formikRefTemplate}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"rowspan"}
                                    label={"Rowspan*:"}
                                    as={"number"}
                                    formikRef={formikRefTemplate}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>

                            <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Annulla</Translate>
                </Button>
                {
                    elemento && elemento.index_livello && elemento.index_sottolivello &&
                    <Button variant="secondary" onClick={() => {
                        aggiungiRiga(elemento, false);
                        handleClose();
                    }}>
                        <Translate>Aggiungi riga</Translate>
                    </Button>
                }
                <Button variant="primary" onClick={salvaElemento}>
                    <Translate>Salva</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}